import React from 'react';
import {Link} from 'react-router-dom';

export default class FooterOne extends React.Component {
    render(){
        let publicUrl = process.env.PUBLIC_URL+'/'
        return (
            <>
                {/* Start Footer One */}
                <footer className="footer-one">
                    <div className="footer-one__top">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="footer-one__top-inner">
                                        <div className="row">

                                            {/* Start Footer Widget Column */}
                                            <div className="col-xl-6 col-lg-6 col-md-6 wow animated fadeInUp" data-wow-delay="0.1s">
                                                <div className="footer-widget__column footer-widget__about">
                                                    <div className="footer-widget__about-logo">
                                                        <Link to={process.env.PUBLIC_URL + `/`}><img src={publicUrl+"assets/images/resources/footerlogobizindex.png"} alt="" /></Link>
                                                    </div>

                                                    <ul className="footer-widget__about-contact-info">
                                                        <li className="d-none">
                                                            <div className="icon">
                                                                <span className="fa fa-clock"></span>
                                                            </div>
                                                            <div className="text">
                                                                <p>Open Hours of Government: <br />Mon-Fri: 08:00 am PST - 05:00 pm PST</p>
                                                            </div>
                                                        </li>

                                                       <li >
                                                            <div className="icon">
                                                                <span className="fa fa-map-marker"></span>
                                                            </div>
                                                            <div className="text d-none ">
                                                                <p>Niku Solutions PTE LTD 133 NEW BRIDGE ROAD #10-03 CHINATOWN POINT, Singapore 521147.</p>
                                                            </div>
                                                             <div className="text">
                                                                <p>All Businesses in One Place</p>
                                                            </div>
                                                        </li>

                                                        <li>
                                                            <div className="icon">
                                                                <span className="fa fa-phone rotate"></span>
                                                            </div>


                                                            <div className="text">
                                                                <p>Your Trusted Business Directory</p>
                                                            </div>

                                                            <div className="text d-none">
                                                                <p><a href="tel:+13602265707">+1 (360) 226-5707</a></p>
                                                            </div>
                                                        </li>
                                                    </ul>

                                                    <div className="footer-widget__about-social-link">
                                                        <ul>
                                                            <li>
                                                                <a href="#">
                                                                    <span className="first icon-facebook-app-symbol"></span>
                                                                    <span className="second icon-facebook-app-symbol"></span>
                                                                </a>
                                                            </li>

                                                            <li>
                                                                <a href="#">
                                                                    <span className="first icon-pinterest"></span>
                                                                    <span className="second icon-pinterest"></span>
                                                                </a>
                                                            </li>

                                                            <li>
                                                                <a href="#">
                                                                    <span className="first icon-twitter"></span>
                                                                    <span className="second icon-twitter"></span>
                                                                </a>
                                                            </li>

                                                            <li>
                                                                <a href="#">
                                                                    <span className="first icon-linkedin"></span>
                                                                    <span className="second icon-linkedin"></span>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* End Footer Widget Column */}

                                            {/* Start Footer Widget Column */}
                                            <div  className="col-lg-6 col-md-6 wow animated fadeInUp text-end" data-wow-delay="0.3s">
                                                <div className="footer-widget__column footer-widget__services">
                                                    <h2 className="footer-widget__title">Directory Services</h2>
                                                    <ul className="footer-widget__services-list">
														<li className="footer-widget__services-list-item">
															<Link to="#">Local Business Search</Link>
														</li>
														<li className="footer-widget__services-list-item">
															<Link to="#">List Your Business</Link>
														</li>
														<li className="footer-widget__services-list-item">
															<Link to="#">Advertising Solutions</Link>
														</li>
														<li className="footer-widget__services-list-item">
															<Link to="#">Premium Placements</Link>
														</li>
														<li className="footer-widget__services-list-item">
															<Link to="#">Review Management</Link>
														</li>
													</ul>
                                                </div>
                                            </div>
                                            {/* End Footer Widget Column */}

                                            {/* Start Footer Widget Column */}
                                            {/* <div className="d-none col-xl-2 col-lg-6 col-md-6 wow animated fadeInUp" data-wow-delay="0.5s">
                                                <div className="footer-widget__column footer-widget__link">
                                                    <h2 className="footer-widget__title">Quick Link</h2>
                                                    <ul className="footer-widget__link-list">
                                                        <li className="footer-widget__link-list-item"><Link to={process.env.PUBLIC_URL + `/`}>Residents</Link></li>
                                                        <li className="footer-widget__link-list-item"><Link to={process.env.PUBLIC_URL + `/`}>Business</Link></li>
                                                        <li className="footer-widget__link-list-item"><Link to={process.env.PUBLIC_URL + `/`}>Online Service</Link></li>
                                                        <li className="footer-widget__link-list-item"><Link to={process.env.PUBLIC_URL + `/`}>Visiting</Link></li>
                                                        <li className="footer-widget__link-list-item"><Link to={process.env.PUBLIC_URL + `/`}>Employment</Link></li>
                                                    </ul>
                                                </div>
                                            </div> */}
                                            {/* End Footer Widget Column */}

                                            {/* Start Footer Widget Column */}
                                            {/* <div className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp" data-wow-delay="0.7s">
                                                <div className="footer-widget__column footer-widget__map">
                                                    <h2 className="footer-widget__title">City Map</h2>
                                                    <div className="footer-widget__map-box">
                                                      <iframe
                                                        src="https://www.google.com/maps?q=Niku%20Solutions%20PTE%20LTD%20133%20New%20Bridge%20Road%20%2310-03%20Chinatown%20Point%20Singapore%20521147&z=16&output=embed"
                                                        className="footer-widget-map__one"
                                                        allowFullScreen>
                                                      </iframe>

                                                    </div>
                                                </div>
                                            </div> */}
                                            {/* End Footer Widget Column */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Start Footer One Bottom */}
                    <div className="footer-one__bottom clearfix">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="footer-one__bottom-inner text-center">
                                        <div className="footer-one__bottom-text">
                                            <p>Copyright © {new Date().getFullYear()} BizIndex. All Rights Reserved.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End Footer One Bottom */}
                </footer>
                {/* End Footer One */}
            </>
        )
    }
}